/**
 * Fetch the product forms for a particular product. This is what we'll load into rex.
 *
 * @param {string} apiQuotingUrl
 * @param {string} productId
 * @param {bool} compact - whether you want the compact form representation
 * @returns {Promise<Object[]>} - An array of objects when fulfilled
 *          {string} Promise<Object[].name>
 */
export default function (_ref) {
  var apiQuotingUrl = _ref.apiQuotingUrl,
      productId = _ref.productId,
      _ref$compact = _ref.compact,
      compact = _ref$compact === void 0 ? false : _ref$compact;
  var url = apiQuotingUrl + "/products/" + productId + "/forms";

  if (compact) {
    url += "?compact=true";
  }

  return fetch(url, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Cache-Control": "no-cache"
    }
  }).then(function (res) {
    if (!res.ok) {
      throw new Error("Could not connect to the server to obtain the product form.");
    }

    return res.json();
  }).then(function (json) {
    // Check to make sure that we received roughly what we're expecting
    // which should be an array, with a single object, with a `name` key
    if (Array.isArray(json) && json[0].name) {
      return json;
    } // Or it might be Composure


    if (typeof json === "object" && json.type === "product-form-bundle") {
      return json;
    } // Also accept a single Composure product-form


    if (typeof json === "object" && json.type === "product-form") {
      return json;
    }

    throw new Error("The product form retrieved from the server appears to be malformed.");
  });
}